// extracted by mini-css-extract-plugin
module.exports = {"Link":"footer_Link__jeVlP","Copyright":"footer_Copyright__1loMw","LeftContainer":"footer_LeftContainer__1b4d8"};